export default __webpack_public_path__ + "static/media/tabs.3afac857.svg";